export enum UpgradePlanDialogVariation {
  TrialEnded = 'TRIAL_ENDED',
  ExceedPositionLimit = 'EXCEED_POSITION_LIMIT',
  MatchDailyLimit = 'MATCH_DAILY_LIMIT',
  NeedMoreMatches = 'NEED_MORE_MATCHES',
}
